<div class="housing" *ngIf="!role">
    <div class="card no-membership">
        <div class="header"></div>
        <div class="cta">Save Time by Creating a Free Account!</div>
        <div class="no-membership-list">As a Free Member, you will receive:</div>
        <ul>
            <li>Access to our versatile author portal</li>
            <li>The ability to store your book info & easily re-run promos</li>
            <li>Insight into your past promo history</li>
            <li>Access to our Facebook Author Community</li>
        </ul>
        <div class="btn-container">
            <button class="btn invert block" routerLink="/signup">Create My Free Account</button>
        </div>
    </div>
    <div class="footer">
        <a href="https://www.writtenwordmedia.com/membership/?utm_source=wwm_author_portal&utm_medium=interstitial&utm_campaign=succes_page_guest" target="_blank">
            <div class="cta">Want to save 10% on your future Promos?</div>
            <div class="color-white">Explore <span class="gold-text underline">Gold</span> & <span class="platinum-text underline">Platinum</span> Membership</div>
            <div class="footer-pup"></div>
        </a>
    </div>
</div>
<div class="housing" *ngIf="role === 'free'">
    <div class="card free">
        <div class="cta saved"> 
            You could
            <span class="secondary-text">
                have saved {{hasEvent ? '': (orderPaymentAmount * .1 | currency:'USD')}}</span> 
            on this order by becoming a Gold or Platinum Member.
        </div>
        <div class="w-700 secondary-text">Gold & Platinum Members receive: </div>
        <ul>
            <li class="eyes">A 10% discount on your promo purchases at Written Word</li>
            <li class="money">Early access to inventory (14 days before anyone else)</li>
            <li class="bell">Priority access to new products (like our new Promo Wizard)</li>
            <li class="flashlight">
                Access to Limelight - a dedicated email that features only you and links to your website, social media accounts and dedicated store
            </li>
            <li class="comment">Instant access to the Written Word team through live chat</li>
            <li class="smile">Savings on other services (Reedsy, PublishDrive, Publisher Rocket and more!)</li>
        </ul>
        <button class="btn invert block" [routerLink]="subscriptionsLink">
            Explore Gold & Platinum Membership
        </button>
    </div>
</div>
<div class="housing" *ngIf="role && role !== 'free'">
    <div class="card" [class]="role">
        <div class="header">
            <div class="texture"></div>
            <div class="wwm-icon"></div>
        </div>
        <div class="cta">Thank you for being a {{roleName}} Member!</div>
        Here is a summary of your available promo credit:
        <div class="father-circle">
            <div class="circular-progress">
                <div class="numbers">
                    <div class="top"><span>${{total}}</span></div>
                </div>
                <div class="text">
                    <span class="value-container" [class]='role'></span>
                    <span class="available-credits">available <br> credit</span>
                </div>
            </div>
        </div>
        <div class="legend">
            <div class="key available"></div>
            <div>{{ available | currency:'USD' }} Available credit</div>
            <div class="key used"></div>
            <div>{{ total - available | currency:'USD' }} Used credit</div>
        </div>
        {{ ctaText }}
        <button class="btn invert block" [routerLink]="billingLink">{{ ctaButtonText }}</button>
    </div>
</div>
